import type { ResolvedPos } from '@tiptap/pm/model';
import type { Selection } from '@tiptap/pm/state';
import { NODE_NAMES } from '@confinion/confideck-shared';
import expandCellSelection, { LIST_TYPES } from './expandCellSelection.helper';

const outermostTableBelow = ($pos: ResolvedPos, depth: number): number => {
  for (let d = depth + 1; d <= $pos.depth; d++) if ($pos.node(d).type.name === NODE_NAMES.table) return d;
  return -1;
};

// One list item gives its own content; a selection across items takes their whole list.
// A table is whole or nothing: a selection that leaves one cell takes every table it touches.
const expandBlockSelection = (selection: Selection): { from: number; to: number } => {
  if ('$anchorCell' in selection) return expandCellSelection(selection);
  const { $from, $to } = selection;
  const depth = $from.sharedDepth($to.pos);
  const shared = $from.node(depth).type.name;
  if (shared === NODE_NAMES.tableRow) return { from: $from.before(depth - 1), to: $from.after(depth - 1) };
  if (shared === NODE_NAMES.table || LIST_TYPES.has(shared))
    return { from: $from.before(depth), to: $from.after(depth) };
  const fromTable = outermostTableBelow($from, depth);
  const toTable = outermostTableBelow($to, depth);
  return {
    from: fromTable < 0 ? selection.from : $from.before(fromTable),
    to: toTable < 0 ? selection.to : $to.after(toTable),
  };
};

export default expandBlockSelection;
